import { styled } from '@spazious/dollhouse-theme';

import { FlexElement, FlexProps } from '../Flex/index.js';
import { Transition } from '../Transition/index.js';

export type BackdropElement = FlexElement;

export interface BackdropProps extends FlexProps {}

export const Backdrop = styled(Transition.Fade).withConfig({
  displayName: 'Backdrop',
})`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
  z-index: -1;
  // CUSTOM PROPS
  background-color: var(--spz-sys-color-backdrop);
  backdrop-filter: blur(10px) opacity(0.75) brightness(0.5);
`;
